// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"9f892290","942":"6ff0f168"}[chunkId] + ".chunk.css";
};